import { useMediaQuery } from '@mui/material'
import { useMemo } from 'react'

export const useIsDesktop = () => {
  const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up('lg'))

  const _isDesktop = useMemo(() => isDesktop, [isDesktop])

  return _isDesktop
}
